import React from 'react';
import AsyncSelect from 'react-select/async';
import chroma from 'chroma-js';

const Select = React.forwardRef((props, ref) => {
  const colourStyles = {
    control: (styles, state) => ({
      ...styles,
      border: state.isFocused ? '1px solid rgba(0,0,0,0.23)' : '1px solid #e7e7e7',
      boxShadow: '0 !important',
      '&:hover': {
        borderColor: state.isFocused && 'rgba(0,0,0,0.23)'
      },
      minWidth: 160
    }),
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      const color = chroma('rgb(255, 227, 63)');
      return {
        ...styles,
        backgroundColor: isDisabled
          ? null
          : isSelected
          ? 'rgb(255, 227, 63)'
          : isFocused
          ? 'rgba(108, 193, 255, 0.2)'
          : null,
        color: isDisabled
          ? '#ccc'
          : isSelected
          ? chroma.contrast(color, 'white') > 2
            ? 'white'
            : '#4a4a4a'
          : '#4a4a4a',
        fontWeight: isSelected ? 700 : null,
        cursor: isDisabled ? 'not-allowed' : 'default',

        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled && isSelected && 'rgb(255, 227, 63)'
        }
      };
    },
    menu: (styles) => ({
      ...styles,
      zIndex: 9950
    }),
    input: (styles) => ({ ...styles }),
    placeholder: (styles) => ({ ...styles, color: '#4A4A4A', fontSize: 14 }),
    singleValue: (styles) => ({ ...styles })
  };
  return (
    <AsyncSelect
      ref={ref}
      cacheOptions
      styles={colourStyles}
      components={{
        IndicatorSeparator: () => null
      }}
      {...props}
    />
  );
});

export default Select;
